import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { ZhhSessionLimitState } from "./zhh-session-limit.model";

const ACTION_PREFIX = "[ZHH Session Limit]";

export const ZHH_SESSION_LIMIT_ACTION_TYPE = {
	get: `${ACTION_PREFIX} Get`,
	getSuccess: `${ACTION_PREFIX} Get Success`,
	getFail: `${ACTION_PREFIX} Get Fail`,

	reset: `${ACTION_PREFIX} Clear`,
};

@Injectable({
	providedIn: "root",
})
export class ZhhSessionLimitAction {
	get(): Action {
		return {
			type: ZHH_SESSION_LIMIT_ACTION_TYPE.get,
		};
	}

	getSuccess(payload: ZhhSessionLimitState): ActionWithPayload {
		return {
			type: ZHH_SESSION_LIMIT_ACTION_TYPE.getSuccess,
			payload,
		};
	}

	getFail(payload: AppError): ActionWithPayload {
		return {
			type: ZHH_SESSION_LIMIT_ACTION_TYPE.getFail,
			payload,
		};
	}

	reset() {
		return {
			type: ZHH_SESSION_LIMIT_ACTION_TYPE.reset,
		};
	}
}
